"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowDialogHeader = exports.IconWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["className", "hasTitle"],
  _excluded2 = ["className"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "windowDialogHeader": "sPdw43",
  "hasTitle": "-xtQXO",
  "iconWrapper": "_1xZr1c"
};
var WindowDialogHeader = exports.WindowDialogHeader = function WindowDialogHeader(_ref) {
  var className = _ref.className,
    hasTitle = _ref.hasTitle,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.windowDialogHeader, hasTitle && styles.hasTitle)
  }));
};
WindowDialogHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  hasTitle: _propTypes["default"].bool
} : {};
var IconWrapper = exports.IconWrapper = function IconWrapper(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.iconWrapper)
  }));
};
IconWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string
} : {};